'use client'
import React from 'react'
import type { Product } from './ProductsCard'
import ProductsCard from './ProductsCard'

interface ProductsCardClientProps {
    ids?: string
    products?: Product[]
}

const ProductsCardClient = ({ ids, products }: ProductsCardClientProps) => {
    return <ProductsCard ids={ids} products={products} />
}

export default ProductsCardClient

